module.exports = __webpack_public_path__ + "VIPV39.png?05c57a6974b0f51241e4622b927a8e5d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV39.png
// module id = 135
// module chunks = 0